import isPlaceholder from 'src/js/modules/extensions/registry/ws-image/helpers/is-placeholder';
import {
  BACKGROUND_IMAGE_ATTRIBUTE,
  BACKGROUND_POSITION_ATTRIBUTE,
  BACKGROUND_PLACEHOLDER_ATTRIBUTE,
  BACKGROUND_HIDDEN_ATTRIBUTE,
} from '../../constants/block-background-attributes';
import { LIVE_PREVIEW_MOCKED_ID } from '../../constants/common';

const handleBackgroundImage = ({ destinationBlockNode, variationId, backgroundOption = [] }) => {
  if (!backgroundOption) {
    return false;
  }

  const { values } = backgroundOption;

  if (
    !values[BACKGROUND_IMAGE_ATTRIBUTE] ||
    backgroundOption.blockNode.hasAttribute(BACKGROUND_HIDDEN_ATTRIBUTE) ||
    backgroundOption.blockNode.hasAttribute(BACKGROUND_PLACEHOLDER_ATTRIBUTE) ||
    !destinationBlockNode.hasAttribute(BACKGROUND_IMAGE_ATTRIBUTE)
  ) {
    return false;
  }

  const shouldCopyPosition =
    variationId === backgroundOption.variationId || variationId === LIVE_PREVIEW_MOCKED_ID;

  Object.entries(values).forEach(([attribute, value]) => {
    switch (attribute) {
      case BACKGROUND_POSITION_ATTRIBUTE: {
        const newValue = shouldCopyPosition ? value : '50% 50%';
        destinationBlockNode.setAttribute(attribute, newValue);
        break;
      }
      default: {
        destinationBlockNode.setAttribute(attribute, value);
        break;
      }
    }
  });

  const shouldRemoveBackgroundPlaceholder =
    isPlaceholder(destinationBlockNode) && !isPlaceholder(backgroundOption.blockNode);

  if (shouldRemoveBackgroundPlaceholder) {
    destinationBlockNode.removeAttribute(BACKGROUND_PLACEHOLDER_ATTRIBUTE);
  }

  return true;
};

export default handleBackgroundImage;
